import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/manualInvoicePaymentMethods', request)
}

export {get}
